import { useEffect, useState } from "react";
import { Button } from "../../../shadcn/components/ui/button";
import { Input } from "../../../shadcn/components/ui/input";
import { BetaForm as useBetaForm } from "@reusejs/react";
import { useSelector } from "react-redux";
import { createFormSchema } from "services";
import { useRouter } from "next/router";
interface UserRoles {
  title?: string;
  value?: string;
}

interface props {
  className?: string;
}

const roles: UserRoles[] = [
  // { title: "Bank Officer", value: "authorized_officer" },
  // {
  //   title: "Appointed Resolution Agent",
  //   value: "appointed_agent",
  // },
  // {
  //   title: "Broker",
  //   value: "broker",
  // },
  // { title: "CIRP Professional", value: "cirp_professional" },
  { title: "Owner", value: "owner" },
  { title: "Property Agent", value: "property_agent" },
];

export const PYPFormsContainer = ({ className }: props) => {
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const { user_type } = router.query;

  const user_uuid = useSelector((state: any) => {
    return state?.auth?.user?.uuid;
  });

  const userProfile = useSelector((state: any) => {
    return state?.auth?.user?.profile;
  });
  const onboardingData = useSelector((state: any) => {
    return state?.auth?.onboarding;
  });

  const userAttributes = useSelector((state: any) => {
    const attributes = state?.auth?.user?.attributes;
    const mobile = attributes?.find(
      (attr: any) => attr.type === "mobile_number",
    );
    return { mobile: mobile?.value };
  });

  const form = useBetaForm({
    role: user_type ?? "",
    name: onboardingData?.name ? onboardingData?.name.trimStart() : "",
    mobile_number: userAttributes.mobile
      ? userAttributes.mobile.slice(3)
      : userProfile?.bio?.mobile_number
      ? userProfile?.bio?.mobile_number
      : "",
  });

  const mobileNumberRegEx: RegExp = /^[0-9]{10}$/;
  const nameRegex: RegExp = /^[a-zA-Z][a-zA-Z\s]*$/;

  const form_constraints = {
    role: {
      presence: {
        allowEmpty: false,
      },
    },
    name: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: nameRegex,
      },
    },
    mobile_number: {
      presence: {
        allowEmpty: false,
      },
      format: {
        pattern: mobileNumberRegEx,
      },
    },
  };

  useEffect(() => {
    form.setValidationRules(form_constraints);
  }, []);

  useEffect(() => {
    if (user_type) {
      form.setField("role", user_type);
    }
  }, [router.query]);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (form.getField("mobile_number") === "") {
        form.setErrors({ mobile_number: ["Please complete your profile"] });
        return;
      }
      if (form.validate()) {
        const payload = {
          user_type: form.getField("role"),
          user_uuid: user_uuid,
        };
        const response: any = await createFormSchema(payload);

        if (response) {
          router.push({
            pathname: `/post-your-property/${response.uuid}`,
            // query: { uuid: response.uuid },
          });

          setLoading(false);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("check here error", error);
    }
  };

  return (
    <div
      className={`clip-path-mobileClipPolygonTopRight h-fit ${className} w-full mid:min-w-[470px] bg-brand-lightPink mid:max-w-[574px] px-3 lg:px-6 pt-11 lg:pt-7 pb-9`}
    >
      <div className="">
        <p className="font-openSans font-normal text-web-h3 leading-[38px] text-brand-bgBlack">
          Please fill in the details
        </p>
        <p className="uppercase mt-8 font-openSans font-semibold text-mobile-body-lg lg:text-web-subheading leading-[22px] lg:leading-6 text-brand-bgBlack">
          {" "}
          You Are
        </p>
        <div className="max-w-[522px] flex flex-wrap gap-4 lg:gap-x-4 lg:gap-y-6 mt-5">
          {roles.map((user: any, index) => (
            <Button
              key={`role-${index}`}
              onClick={() => {
                form.setField("role", user?.value);
              }}
              size={"custom"}
              variant={"custom"}
              className={`px-9 py-3 rounded-full hover:bg-brand-lightOrange ${
                form.getField("role") === user?.value
                  ? "bg-brand-lightOrange"
                  : "bg-white"
              } font-openSans font-normal text-mobile-body-sm lg:text-web-body-md leading-4 text-brand-bgBlack`}
            >
              {user?.title}
            </Button>
          ))}
        </div>
        {form.errors.get("role") ? (
          <p className="text-sm text-red-500">{form.errors.get("role")[0]}</p>
        ) : null}
        <div className="space-y-3">
          <p className="uppercase mt-10 lg:mt-8 font-openSans font-semibold text-mobile-body-lg lg:text-web-subheading leading-[22px] lg:leading-6 text-brand-bgBlack">
            Personal details
          </p>
          <div>
            <Input
              placeholder="Your Name*"
              value={form.getField("name")}
              disabled={onboardingData?.name ? true : false}
              onChange={(e) => {
                form.setField("name", e.target.value);
              }}
              className="bg-gray-100 hover:cursor-not-allowed py-4  outline-none pl-6 border  w-full placeholder:text-brand-borderGrey   font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey"
            />{" "}
            {form.errors.get("name") ? (
              <p className="text-sm text-red-500">
                {form.errors.get("name")[0]}
              </p>
            ) : null}
          </div>

          <div>
            <Input
              placeholder="Mobile Number*"
              disabled={true}
              value={form.getField("mobile_number")}
              onChange={(e) => {
                form.setField("mobile_number", e.target.value);
              }}
              className="bg-gray-100 py-4 hover:cursor-not-allowed outline-none pl-6 border placeholder:text-mobile-body-sm  w-full placeholder:text-brand-borderGrey   font-openSans font-normal text-web-body-sm leading-4 text-brand-textLightGrey"
            />{" "}
            {form.errors.get("mobile_number") ? (
              <p className=" text-sm text-red-500">
                {form.errors.get("mobile_number")[0]}
              </p>
            ) : null}
          </div>
        </div>
      </div>

      <Button disabled={loading} onClick={handleSubmit} className="w-full mt-8">
        Submit
      </Button>
    </div>
  );
};
export default PYPFormsContainer;
